<template>
	<div>
		<div class="main">
			<div class="main_nav">
				<ul class="text d-rn d-aic d-jcs">
					<li class="showHand" @click="handleReturnMyInfo">订单详情</li>
					<li>></li>
					<li style="color: #333333;">订单：{{shop_infos.order_id||''}}</li>
				</ul>
				<p class="line1"></p>
		
				<!-- 其他类型 -->
				<div class="productlist">
					<div class="producttop">
						<ul class="proMenu">
							<li>商品信息</li>
							<li>商品数量</li>
							<li>订单编号</li>
							<li>创建时间</li>
							<li>支付方式</li>
						</ul>
						<ul class="proMenuList d-rn d-aic d-jcs">
							<!-- v-for="(item,index) in 3" :key="index" -->
							<li class="firstLi">
								<img :src="shop_infos.img">
								<p class="proDetailNav txt-cuts">{{shop_infos.name}}</p>
							</li>
							<li class="num one-txt-cut">{{shop_infos.num}}</li>
							<li class="orderNum one-txt-cut">{{shop_infos.order_id}}</li>
							<li class="createTime one-txt-cut">{{shop_infos.time}}</li>
							<li class="payType one-txt-cut" style="flex: 1;text-align: left;">{{shop_infos.pay==2?'支付宝支付':'微信支付'}}</li>
						</ul>
					</div>
				</div>
				
				
				<div>
					<div class="productlist">
						<!-- 描述相符 -->
						<div class="lable">
							<div class="texts">描述相符：</div>
							<div>
								 <el-rate v-model="pf1"  :colors="colors"></el-rate>
							</div>
						</div>
						
						<!-- 内容描述 -->
						<div class="l-one">
							<el-input type="textarea" :rows="6" placeholder="在此输入文字描述" v-model="textarea" resize="none" />
						</div>
						
						<!-- 上传图片 -->
						<div class="l-one2 d-flex d-aic flex-wrop" style="width: 100%;">
							<template v-if="upFileImgHeader.length>0">
							
								<template v-for="(item,index) in upFileImgHeader">
									<div class="l-one-img por">
										<img :src="item" >
										<img class="clear-img" src="../../assets/img/comm/clear.png" @click="del_img(index)" >
									</div>
								</template>
							</template>
							
							<div class="por l-one-img">
								<img src="../../assets/img/new/paizhao.png" >
								<el-upload style="position: absolute;width: 100%;height: 100%;background-color: red;
								top: 0;left: 0;opacity: 0;"
								:action="requestUrl"
								:show-file-list="false"
								:on-success="handleAvatarSuccess">
								  <i  class="el-icon-plus avatar-uploader-icon" style="position: absolute;width: 100%;height: 100%;background-color: red;
								top: 0;left: 0;"></i>
								</el-upload>
							</div>
						</div>
						
						<!-- 物流服务 -->
						<div class="lable">
							<div class="texts">物流服务：</div>
							<div>
								 <el-rate v-model="pf2"  :colors="colors"></el-rate>
							</div>
						</div>
						
						<!-- 服务态度 -->
						<div class="lable mt-3">
							<div class="texts">服务态度：</div>
							<div>
								 <el-rate v-model="pf3"  :colors="colors"></el-rate>
							</div>
						</div>
						
						<button type="button" class="showHand my-btns" style="background-color:#e62129;" @click="throttle(btn,1500)">保存</button>
					</div>
				</div>
				

			</div>
			

		</div>
		
	</div>
</template>

<script>
	import {
		appCUserorderList, 			// 获取评价商品
		addAppCComments, 			// 提交评价
	} from '../../api/order.js'
	export default {
		data(){
			return{
				// 评分
				pf1:0,
				pf2:0,
				pf3:0,
				
				textarea:'', 							// 具体评价
				orderCodeId:'',
				colors:['#99A9BF', '#F7BA2A', '#FF9900'],
				requestUrl:this.$store.getters.upImgUrl,
				upFileImgHeader:[],
				goodid:null,
				
				shop_name:null,
				shop_img:null,
				shop_id:null,
				
				userInfo:null,
				
				isrequest:true, 			// 允许请求
				
				shop_infos:null
				
			}
		},
		created() {
			// 用户信息处理===用户信息传递
			this.userInfo=this.getUInfo();
		},
		mounted() {
		
			this.shop_infos = JSON.parse(this.$route.query.data)
			console.log('要评价的商品信息=====',this.shop_infos);
			this.goodid = this.shop_infos.order_id
			this.get_shop_info()
			// // 监听参数
			// _self.$EventBus.$on('my_evaluate',res=>{
			// 	// console.log('myinfo===下标变化',res);
			// 	// 定义显示组件
			// 	_self.goodid=res;
			// })
		},
		methods:{
			
			// 没用上
			handleReturnMyInfo(){
				// this.$router.replace({name:'MyInfo'})
				this.$router.go(-1);
			},
			
			// 图片上传成功
			handleAvatarSuccess(res){
				console.log('========');
				if(res){
					this.upFileImgHeader.push(res)
				}
			},
			
			// 移除提交图片
			del_img(index){
				this.upFileImgHeader.splice(index,1)
			},
			
			
			// 获取评价商品
			get_shop_info(){
				appCUserorderList({orderId:this.goodid}).then(res=>{
					console.log('获取的商品========',res);
					if(res.code==200){
						this.shop_name = res.data.goodsTitle
						this.shop_img = res.data.goodsImg
						this.shop_id = res.data.goodsId
						console.log(this.shop_name);
						console.log(this.shop_img);
						console.log(this.shop_id);
					}
				})
			},
			
			// 提交
			btn(){
				if(this.textarea.length==0){  this.$eror('评价内容不能为空');; return; }
				let data = {
					orderId:this.shop_infos.order_id, 	// 订单id
					descriptionScore:this.pf1, 			// 描述评分
					logisticsScore:this.pf2,				// 物流评分
					serviceScore:this.pf3,				// 服务评分
					commentsImage:this.upFileImgHeader.toString(),							// 图片
					commentsContent:this.textarea,				// 建议
					userId:this.userInfo.userId,
				}
				
				// 是否允许请求
				if(!this.isrequest) return;
				this.isrequest=false;
				
				addAppCComments(data).then(res=>{
					console.log('提交成功=====',res);
					if(res.code==200){
						// 提示修改成功
						this.$message({ message:'提交成功', type:'success' })
						setTimeout(()=>{
							this.$router.go(-1)
						},1000)
						// 允许再次请求
						this.isrequest=true;
					}else{
						_self.$eror('提交失败')
						// 允许再次请求
						this.isrequest=true;
					}
				}).catch(err=>{
					this.isrequest=true;
				})
			}
			
			
		}
	}
</script>

<style scoped>
	.l-one{
		margin-top: 15px;
	}
	.l-one2{
		margin-top: 30px;
	}
	.mt-3{
		margin-top: 30px;
	}

	.main {
		width: 100%;
		padding-bottom: 40px;
		box-sizing: border-box;
		background: #f5f5f5;
		display: flex;
		flex-direction: column;
	}
	
	.main_nav {
		width: 1200px;
		min-height: 750px;
		margin: 0 auto;
		background-color: #F5F5F5;
	}

	.text {
		padding: 40px 0 35px 0;
		box-sizing: border-box;
		height: 24px;
		font-size: 18px;
		font-weight: 400;
		color: #999999;
		letter-spacing: 2px;
		display: flex;
		flex-direction: row;
	}

	.text li {
		margin-right: 10px;
	}

	.line {
		width: 1200px;
		height: 4px;
		background: #e62129;
	}

	/* 产品信息 */
	.productlist {
		width: 1200px;
		padding: 20px 30px;
		box-sizing: border-box;
		background: #ffffff;
		margin-bottom: 20px;
	}

	.producttop {
		display: flex;
		flex-direction: column;
	}

	.proMenu {
		width: 100%;
		height: 44px;
		background-color: #F5F5F5;
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-top: 20px;
	}

	.proMenu1 {
		width: 100%;
		height: 44px;
		background-color: #F5F5F5;
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-top: 20px;
	}

	.proMenu li {
		font-size: 16px;
		font-weight: 400;
		color: #666666;
		letter-spacing: 2px;
		margin-left: 137px;
	}

	.proMenu li:nth-child(1) {
		/* border: 1px solid red; */
		margin-left: 120px;
	}

	.proMenu1 li {
		font-size: 16px;
		font-weight: 400;
		color: #666666;
		letter-spacing: 2px;
		margin-left: 166px;
	}

	.proMenu1 li:nth-child(1) {
		/* border: 1px solid red; */
		margin-left: 176px;
	}

	.proMenuList {
		display: flex;
		flex-direction: row;
		align-items: center;
		/* justify-content: space-around; */
		padding: 25px 0;
		box-sizing: border-box;
		border-bottom: 2px solid #F1F1F1;
		/* border: 1px solid red; */
	}

	.proMenuList li {
		font-size: 14px;
		font-weight: 400;
		color: #333333;
		letter-spacing: 2px;
		/* border: 2px solid green; */

	}

	.firstLi {
		width: 280px;
		display: flex;
		flex-direction: row;
		align-items: center;
		/* border: 2px solid black; */
		margin-left: 15px;
	}

	.firstLi1 {
		width: 280px;
		display: flex;
		flex-direction: row;
		align-items: center;
		/* border: 2px solid black; */
		margin-left: 60px;
	}
	.firstLi1 img {
		width: 60px;
		height: 60px;
		display: flex;
		margin-right: 10px;
	}
	.firstLi img {
		width: 60px;
		height: 60px;
		display: flex;
		margin-right: 10px;
	}
	.num {
		width: 50px;
		text-align: center;
		margin-left: 45px;
	}

	.createTime {
		width: 200px;
		text-align: center;
		margin-left: 45px;
	}

	.payType {
		width: 80px;
		text-align: center;
		margin-left: 60px;
	}

	.proDetailNav {
		font-size: 16px;
		font-weight: 400;
		color: #333333;
		letter-spacing: 2px;
		flex: 1;
	}
	
	.form li textarea {
		width: 430px;
		height: 300px !important;
		background: #ffffff;
		border: 1px solid #cccccc;
		border-radius: 2px;
		color: #999999;
		font-size: 16px;
		padding: 10px 15px;
		box-sizing: border-box;
	}

	button {
		width: 72px;
		height: 30px;
		background: #3239ff;
		font-size: 14px;
		font-weight: 400;
		color: #ffffff;
		letter-spacing: 1px;
		margin: 30px 126px;
		box-sizing: border-box;
	}
	
	.lable {
		display: flex;
		align-items: center;
	}
	.lable .texts{
		font-size: 16px;
		font-weight: 700;
		color: #333333;
		letter-spacing: 1px;
	}
	.l-one-img{
		width: 106px;
		height: 106px;
		margin-right: 30px;
		margin-bottom: 30px;
	}
	.l-one-img img{
		width: 100%;
		height: 100%;
	}
	.l-one-imgs{
		display: flex;
		align-items: center;
	}
	.clear-img{
		position: absolute;
		top: -8px;
		right: -8px;
		width: 24px !important;
		height: 24px !important;
	}
	.orderNum{
		width: 140px;
		text-align: center;
		margin-left: 120px;
	}
	.orderNum1{
		width: 140px;
		text-align: center;
		margin-left: 150px;
	}
	.my-btns{
		margin-left: 0 !important;
		margin-right: 0 !important;
	}
</style>
